import React from 'react'

function BooAccRec() {
  return (
    <head style={{all:'initial'}}>
                <title>أفضل محاسب قانوني بالرياض</title>
                <meta name="description" content="أفضل محاسب قانوني بالرياض"/>
                <meta name="keywords" content="أفضل محاسب قانوني بالرياض" />
            </head>
  )
}

export default BooAccRec